import UIkit from 'uikit';
$(document).ready(function( $ ) {
    if(window.location.hash=='#so-contact') {
        $("html, body").delay(0).animate({scrollTop: $('#so-contact').offset().top }, 1000);
    }
});